module.exports = __webpack_public_path__ + "img/zhuxue.7065ca2a.jpg";